import { load } from '@/router/routes/index';

export default [
    {
        path: 'settings',
        name: 'settings',
        component: load('layouts/Settings'),
        children: [
            {
                path: '',
                redirect: { name: 'settings.general' },
            },
            {
                path: 'general',
                name: 'settings.general',
                component: load('SettingsGeneral'),
                meta: { auth: true },
            },
            {
                path: 'appearance',
                name: 'settings.appearance',
                component: load('SettingsAppearance'),
                meta: { auth: true },
            },
            {
                path: 'users',
                name: 'user.index',
                component: load('user/UserIndex'),
                meta: { auth: true },
            },
            {
                path: 'roles',
                name: 'role.index',
                component: load('role/RoleIndex'),
                meta: { auth: true },
            },
            {
                path: 'related-users',
                name: 'related-users.index',
                component: load('related-users/RelatedUsersIndex'),
                meta: { auth: true },
            },
            {
                path: 'related-users/create',
                name: 'related-users.create',
                component: load('related-users/RelatedUsersCreate'),
                meta: { auth: true, forceCollapsedMenu: true },
            },
            {
                path: 'newsletter/mailup',
                name: 'settings.newsletter.mailup',
                component: load('SettingsMailup'),
                meta: { auth: true },
            },
        ],
    },
];
